import { Box, TextField } from "@mui/material";

function FirstStep() {
  return(

    <><h1 className="text-[color:--primary-color] text-center uppercase font-extrabold text-2xl pb-6">comece a gerenciar seu coworking</h1>

    <Box className="w-96 m-auto flex flex-col justify-center items-center my-1 lg:my-3"
      sx={{ '& > :not(style)': { m: 1 } }}
      component="form"
      noValidate
      autoComplete="off">
      <TextField className="bg-[#F5F5F5] rounded-lg w-80 lg:w-96" id="filled-basic" variant="filled" label="Nome do Coworking" placeholder="" />

      <TextField className="bg-[#F5F5F5] rounded-lg w-80 lg:w-96" id="filled-basic" variant="filled" label="E-mail do Coworking" placeholder="example@example.com" />

      <TextField className="bg-[#F5F5F5] rounded-lg w-80 lg:w-96" id="filled-basic" variant="filled" label="Telefone" placeholder="(00)00000-0000" />

      <TextField className="bg-[#F5F5F5] rounded-lg w-80 lg:w-96" id="filled-basic" variant="filled" label="Endereço" placeholder="" />

    </Box></>
  )
}

export default FirstStep;